import React, { Fragment } from "react";
import { Row, Col, FormGroup, Label, Input, Form } from "reactstrap";
import { useQuery } from "@apollo/client";
import { GET_ALL_COLLABORATION_NEEDS } from "../query/formQueries";
import { useSupporterSignUpContext } from "../context/SupporterStatusContext";

const collaborationExperienceTimeOptions = [
  "全く経験が無い",
  "ほとんど経験が無い ",
  "複数回経験がある",
  "十回以上経験がある",
];

const Step1Cso = ({ update }) => {
  const { state, dispatch, backToInitialPage } = useSupporterSignUpContext();

  const {
    data: collaborationNeeds,
    loading: collaborationNeedsLoading,
    error: collaborationNeedsError,
  } = useQuery(GET_ALL_COLLABORATION_NEEDS);
  const step1Fields = [
    {
      name: "collaborationExperienceTime",
      enLabel: "Collaboration Experience with CSO",
      jpLabel: "CSOとの連携経験",
      type: "radio",
      options: collaborationExperienceTimeOptions.map((item) => ({
        label: item,
        value: item,
      })),
      onChange: (e) => {
        dispatch({
          type: "HANDLE_RADIO_CHANGE",
          payload: {
            name: e.target.name,
            value: e.target.value,
          },
        });
      },
    },
    {
      name: "collaborationNeeds",
      enLabel: "Collaboration Needs",
      jpLabel: "連携方法・ニーズ",
      type: "checkbox",
      options: collaborationNeeds?.allCollaborationNeeds?.edges?.map(
        (item) => ({
          label: item.node.title,
          value: update ? Number(item.node.intId) : Number(item.node.intId),
        })
      ),
      onChange: (e) => {
        dispatch({
          type: "HANDLE_CHECKBOX_CHANGE",
          payload: {
            name: e.target.name,
            value: e.target.value,
            checked: e.target.checked,
          },
        });
      },
    },
  ];
  return (
    <Fragment>
      <div className="form-wizard-content">
        <Form>
          {step1Fields.map((field) => {
            return (
              <FormGroup inline={true}>
                <Row>
                  <Col xs={12} md={3}>
                    <Label for={field.name} className="mr-sm-2">
                      {field.jpLabel}
                      {field.required && (
                        <span
                          style={{
                            backgroundColor: "#FF6D6D",
                            color: "white",
                            padding: "2px 4px",
                            borderRadius: "2px",
                            fontSize: "9px",
                            marginLeft: "8px",
                          }}
                        >
                          必須
                        </span>
                      )}
                    </Label>
                  </Col>
                  <Col xs={12} md={9}>
                    {field.type === "textArea" && (
                      <Input
                        type="textarea"
                        name={field.name}
                        id={field.name}
                        {...(field.onChange && {
                          onChange: (e) => {
                            field.onChange(e);
                          },
                        })}
                        defaultValue={state[field.name]}
                      />
                    )}
                    {field.type === "text" && (
                      <Input
                        type={field.type}
                        name={field.name}
                        id={field.name}
                        placeholder={field?.placeholder ?? ""}
                        // {...(field.required && { required: true })}
                        {...(field.onChange && {
                          onChange: (e) => {
                            field.onChange(e);
                          },
                        })}
                        defaultValue={state[field.name]}
                      />
                    )}
                    {(field.type === "radio" || field.type === "checkbox") && (
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          marginLeft: "20px",
                        }}
                      >
                        {field?.options?.map((option) => {
                          return (
                            <Label
                              check
                              style={{
                                marginRight: "36px",
                                marginBottom: "8px",
                              }}
                            >
                              <Input
                                type={field.type}
                                name={field.name}
                                value={option.value}
                                defaultChecked={state[field.name].includes(
                                  option.value
                                )}
                                {...(field.onChange && {
                                  onChange: (e) => {
                                    field.onChange(e);
                                  },
                                })}
                              />{" "}
                              {option.label}
                            </Label>
                          );
                        })}
                      </div>
                    )}
                    {field.type === "select" && (
                      <Input
                        type="select"
                        name={field.name}
                        id={field.name}
                        // {...(field.required && { required: true })}
                        {...(field.onChange && {
                          onChange: (e) => {
                            field.onChange(e);
                          },
                        })}
                        defaultValue={state[field.name]}
                      >
                        {field.options.map((option) => {
                          return (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          );
                        })}
                      </Input>
                    )}
                  </Col>
                </Row>
              </FormGroup>
            );
          })}
        </Form>
      </div>
    </Fragment>
  );
};
export default Step1Cso;
